module.exports = __webpack_public_path__ + "img/liuxinyu.16ed83eb.png";